import SubLabel from "components/Atoms/Sublabel";
import BrandIcon from "components/BrandIcon";
import { DotLabel } from "components/Dot";
import Tag from "components/Tag/Tag";
import React from "react";
import { Button } from "semantic-ui-react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  user: server.dto.UserForAdminOne
}

const capitalize = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const isAccessibleByUser = (toClient: server.dto.ToClientRelationshipForAdminOne) => {
  return ["activeTrial", "activeFree", "activePaid", "activeReadOnly", "temporarilyOpened"].includes(toClient.client.access);
};

const impersonateButtonColor = (user: server.dto.UserForAdminOne, toClient: server.dto.ToClientRelationshipForAdminOne) => {
  if (user.access.value !== "hasAccess") {
    return "red";
  }

  if (toClient.lifeCycle.value !== "active") {
    return "red";
  }

  if (!isAccessibleByUser(toClient)) {
    return "red";
  }

  if (toClient.canConfigureSystemSettings) {
    return "green";
  }

  return "blue";
};

const ToClientRelation = ({ user }: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const onImpersonate = (e: React.SyntheticEvent, userToClientId: number) => {
    e.preventDefault();
    setIsLoading(true);
    window.CoreApi.Authentication.Impersonate({ userToClientId })
      .then((response) => {
        if (response.data.hasErrors) {
          setIsLoading(false);
          window.displayGenericModal(RESX.ExceptionMessage.ThereIsAProblem, response.data.errors[0].message, "tiny", "error");
        } else {
          window.location.href = routes.dashboard().absolute;
        }
      });
  };

  return <table className="s1_table list" style={{ border: "1px solid #ddd" }}>
    <tbody>
      {user.toClients.map((toClient) => <tr key={toClient.client.clientId}>
        <td style={{ width: 40 }}>
          <BrandIcon
            name={toClient.client.name}
            size={40}
            iconUrl={toClient.client.iconUrl}
          />
        </td>
        <td>
          <div>
            <a href={routes.client_DetailAdminOne(toClient.client.clientId).absolute}>{toClient.client.name}</a>
            <SubLabel>client:{toClient.client.clientId} | u2c:{toClient.userToClientId}</SubLabel>
          </div>
          <div>
            <Tag
              label={RESX.ClientAccessLabels[capitalize(toClient.client.access)]}
              color={RESX.ClientAccessHexColors[capitalize(toClient.client.access)]}
            />
          </div>
        </td>
        <td style={{ width: 100 }}>

          <div>
            <DotLabel dotColor={toClient.lifeCycle.hexColor}>{toClient.lifeCycle.text}</DotLabel>
          </div>

          <div>
            <Tag
              label={capitalize(toClient.environment)}
              color={toClient.environment === "internal" ? "#119BF5" : "#f39c12"}
            />
          </div>

          {toClient.canConfigureSystemSettings && <div>
            <DotLabel dotColor="green">
              Admin
            </DotLabel>
          </div>}

        </td>
        <td style={{ width: 130 }}>
          <Button
            small
            loading={isLoading}
            color={impersonateButtonColor(user, toClient)}
            onClick={e => { onImpersonate(e, toClient.userToClientId); }}>
            Impersonate
          </Button>
        </td>
      </tr>)}
    </tbody>
  </table>;
};

export default ToClientRelation;